export const ETAT_ETAPE_TRAITEMENT_LIST_REQUESTING = 'etat-etape-traitements/ETAT_ETAPE_TRAITEMENT_LIST_REQUESTING';
export const ETAT_ETAPE_TRAITEMENT_LIST_SUCCESS = 'etat-etape-traitements/ETAT_ETAPE_TRAITEMENT_LIST_SUCCESS';
export const ETAT_ETAPE_TRAITEMENT_LIST_FAILED = 'etat-etape-traitements/ETAT_ETAPE_TRAITEMENT_LIST_FAILED';
